import request from '@/utils/zsm-requets'

// 获取課程分类
/*  level 	多少级目录，从0开始
    parentCode   父类编码,不填=顶级
  */
export function classifyListData(params) {
  return request({
    url: '/zsm/api/classify/listData',
    method: 'post',
    params
  })
}

/* 参数设置-获取特定key对应的value */
export function settingConfig(key) {
  return request({
    url: '/zsm/api/setting/config',
    method: 'post',
    params: { key }
  })
}

/* 字典管理-获取某个字典的所有值的集合 */
export function settingDict(dictType) {
  return request({
    url: '/zsm/api/setting/dict',
    method: 'post',
    params: { dictType }
  })
}

/* 获取某个字典里某个值，对应的文字 */
export function settingDictLabel(dictType, dictValue) {
  return request({
    url: '/zsm/api/setting/dictLabel',
    method: 'post',
    params: { dictType, dictValue }
  })
}

// 获取某个字典某个文字，对应的值
export function settingDictValue(dictType, dictLabel) {
  return request({
    url: '/zsm/api/setting/dictValue',
    method: 'post',
    params: { dictType, dictLabel }
  })
}

/* uploadToken 获取七牛云上传文件的token
   params filePath  文件地址
   params title  文件标题

 */
export function ossUploadToken(filePath, title) {
  return request({
    url: '/zsm/api/oss/uploadToken',
    method: 'post',
    params: { filePath, title }
  })
}
/**
 * 刷新阿里云token使用
 * videoId 视频id
 * @returns {*}
 */
export function refreshToken(videoId) {
  return request({
    url: '/zsm/api/oss/refreshToken',
    method: 'post',
    params: { videoId }
  })
}


/*  获取标签列表*/
export function labelListData() {
  return request({
    url: '/zsm/api/label/listData',
    method: 'post',
    params: { pageSize: 9999 }
  })
}

/*  查看模板列表*/
export function templateListData() {
  return request({
    url: '/zsm/api/template/listData',
    method: 'post',
    params: {}
  })
}

/*  查看单个模板详情*/
export function getTemplate(id) {
  return request({
    url: '/zsm/api/template/get',
    method: 'post',
    params: { id }
  })
}
